<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Ledger Master</b-navbar-brand>

          <b-button v-if="
                  $sessionsStorage.get('designation') == 'Admin' &&
                  $sessionsStorage.get('nameUser') == 'Bhavneesh'
                " size="sm" class="ml-1" @click="getReports('Ledger_Master_List')"
            variant="outline-info">Export</b-button>

       
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12">
                  <h5>{{LedgerMaster.ledgerId?'Update ':'Add '}} {{LedgerMaster.ledger}} Ledger Details</h5>
                </b-col>
                <b-col md="3">
                  <label>
                    Ledger Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="ledger" name="ledger"
                    v-model="LedgerMaster.ledger"
                    :disabled="($sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh')?false:LedgerMaster.ledgerId ?true:false"
                    placeholder="Ledger Name"></b-form-input>
                  <span class="error" v-if="!LedgerMaster.ledger">
                    {{
                    errorList.ledger
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Income Direct
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="incomeDirect" name="incomeDirect"
                    v-model="LedgerMaster.incomeDirect"
                    :disabled="($sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh')?false:LedgerMaster.ledgerId ?true:false"
                    placeholder="Income Direct"></b-form-input>
                  <span class="error" v-if="!LedgerMaster.incomeDirect">
                    {{
                    errorList.incomeDirect
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Shipment Type
                    <span class="error">*</span>
                  </label>
                  <multi-select :options="shipmentTypeList" :selected-options="shipmentType_items"
                    v-model="LedgerMaster.shipmentType" placeholder="Select Shipment Type" :multiple="true"
                    @select="SelectMultishipmentType"></multi-select>
                  <span class="error" v-if="!LedgerMaster.shipmentType">
                    {{
                    errorList.shipmentType
                    }}
                  </span>
                  <!-- <model-list-select class="ml-1" :list="shipmentTypeList" id="shipmentType"
                    v-model="LedgerMaster.shipmentType" option-value="value" option-text="text"
                    placeholder="Select Shipment Type"></model-list-select>
                  <span class="error" v-if="!LedgerMaster.shipmentType">
                    {{
                    errorList.shipmentType
                    }}
                  </span> -->
                </b-col>
                <b-col md="3">
                  <label>
                    Module Type
                    <span class="error">*</span>
                  </label>
                  <!-- <model-list-select
                    class="ml-1"
                    :list="moduelTypeList"
                    id="moduelType"
                    v-model="LedgerMaster.moduelType"
                    option-value="text"
                    option-text="moduelTypeText"
                    placeholder="Select Module Type"
                  ></model-list-select>-->
                  <multi-select :options="moduelTypeList" :selected-options="moduelType_items"
                    v-model="LedgerMaster.moduelType" placeholder="Select Module Type" :multiple="true"
                    @select="SelectMultimoduelType"></multi-select>
                  <span class="error" v-if="!LedgerMaster.moduelType">
                    {{
                    errorList.moduelType
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Job Type
                    <span class="error">*</span>
                  </label>
                  <multi-select :options="jobTypeList" :selected-options="jobType_items" v-model="LedgerMaster.jobType"
                    placeholder="Select Job Type" :multiple="true" @select="SelectMultijobType"></multi-select>

                  <!-- <model-list-select
                    class="ml-1"
                    :list="jobTypeList"
                    id="jobType"
                    v-model="LedgerMaster.jobType"
                    option-value="jobTypeVal"
                    option-text="jobTypeText"
                    placeholder="Select Job Type"
                  ></model-list-select>-->
                  <span class="error" v-if="!LedgerMaster.jobType">
                    {{
                    errorList.jobType
                    }}
                  </span>
                </b-col>

                <b-col md="3">
                  <label>
                    Status :
                    <span class="error">*</span>
                  </label>
                  <md-switch :id="'approval'+LedgerMaster.isLedgerActive" name="approval" class="md-primary"
                    :value="LedgerMaster.isLedgerActive==true?true:false" @change="activateLedgerMaster()">
                    <h6>
                      <b-badge
                        :variant="LedgerMaster.isLedgerActive==1?'success':'danger'">{{LedgerMaster.isLedgerActive==1?"Active":"In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col cols="12">
                  <table class="table table-sm table-bordered mt-2">
                    <tbody style="background: white">
                      <tr v-if="TAXPercentageArr.length > 0">
                        <th scope="col" style="width: 5px">SN.</th>
                        <th scope="col" style="width: 200px">Percentage</th>
                        <th scope="col" style="width: 5px">
                          Actions
                          <b-button @click="addMultiTaxPercentage()" size="sm">
                            <i class="fa fa-plus-circle ml-1"></i>
                          </b-button>
                        </th>
                      </tr>
                      <tr v-for="(item, index) in TAXPercentageArr" :key="index">
                        <th scope="row">{{ index + 1 }}.</th>
                        <td>
                          <b-form-input :formatter="capitalizeAll" v-model="item.tax_percentage" type="number"
                            placeholder="Enter Tax Percentage" @input="getTaxPercentage(item)"></b-form-input>
                          <span class="error" v-if="item.tax_percentage_err ? true : false">{{ item.tax_percentage_err
                            }}</span>
                        </td>
                        <td>
                          <b-button v-if="index > 0" size="sm" @click="removeMultiTaxPercentage(index)">
                            <i class="fa fa-minus-circle" aria-hidden="true"></i>
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addLedgerMaster" class="mt-2"
                      id="addButtonLoader">
                      {{
                      LedgerMaster.ledgerId ? "Update" : "Save"
                      }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="6" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Ledger Master and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>
                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
                <b-col md="4">
                  <input type="file" @change="handleFileUpload" accept=".xlsx, .xls" />
                  <span v-if="isFileLoading" >Uploading.....<b-spinner small label="Small Spinner"></b-spinner></span>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="MasterLedgerList" :fields="fields" :current-page="currentPage"
                  :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                  :sort-direction="sortDirection" @filtered="onFiltered" responsive primary-key="ledgerId"
                  class="position-relative">
                  <template slot="ledgerId" slot-scope="row0">
                    <span>
                      {{
                      row0.index + 1 + (currentPage - 1) * perPage
                      }}
                    </span>
                  </template>
                  <template slot="ledger" slot-scope="row1">
                    <span>{{ row1.item.ledger }}</span>
                  </template>
                  <template slot="incomeDirect" slot-scope="row1">
                    <span>{{ row1.item.incomeDirect }}</span>
                    <br />
                  </template>
                  <template slot="shipmentType" slot-scope="row2">
                    <span>Shipment Type : {{ row2.item.shipmentType }}</span>
                    <br />
                    <span>Module Type : {{ row2.item.moduelType }}</span>
                    <br />
                    <span>Job Type : {{ row2.item.jobType }}</span>
                  </template>
                  <template slot="isLedgerActive" slot-scope="row3">
                    <!-- <h6>
                      <b-badge
                        :variant="row3.item.isLedgerActive==1?'success':'danger'"
                      >{{row3.item.isLedgerActive==1?"Active":"In-Active" }}</b-badge>
                    </h6> -->

                    <div v-if="adminToggle == 'Admin'" :id="'row' + row3.item.ledgerId">
                      <md-switch :id="'approval' + row3.item.ledgerId" name="approval" class="md-primary"
                        :value="row3.item.isLedgerActive == 1 ? true : false" @change="activateUser(row3.item)">
                        <h6>
                          <br />
                          <b-badge style="margin-left: -45px">{{
                            row3.item.isLedgerActive == 1 ? "Active" : "In-Active"
                            }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row3.item.ledgerId">
                      <h6>
                        <b-badge>{{
                          row3.item.isLedgerActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                      </h6>
                    </div>

                  </template>
                  <template slot="is_air" slot-scope="row3">
                    <div v-if="adminToggle == 'Admin'" :id="'row' + row3.item.ledgerId">
                      <md-switch :id="'approval' + row3.item.ledgerId" name="approval" class="md-primary"
                        :value="row3.item.is_air == 1 ? true : false" @change="changeToAir(row3.item)">
                        <h6>
                          <br />
                          <b-badge style="margin-left: -45px">{{
                            row3.item.is_air == 1 ? "Active" : "In-Active"
                            }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row3.item.ledgerId">
                      <h6>
                        <b-badge>{{
                          row3.item.is_air == 1 ? "Air" : "Normal"
                          }}</b-badge>
                      </h6>
                    </div>

                  </template>
                  <template slot="creationTime" slot-scope="row3">{{row3.item.creationTime}}</template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editLedgerLocation(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
import CustomLoader from "../common/customLoader.vue";
import { read, utils, writeFile } from "xlsx";
import NodeLockPannelService from "../../services/NodeLockPannelService";
export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch("setCurrentRoute", "/LedgerMaster");
      if (globalPermissionStatus("Ledger Master") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("Ledger Master")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      this.getData();
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      excelData: [], 
      isFileLoading:false,
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "ledgerId",
          label: "SN.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "ledger",
          label: "Ledger Name",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "incomeDirect",
          label: "Income Direct",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "shipmentType",
          label: "Shipment Type",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isLedgerActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "is_air",
          label: "Air Status",
          sortable: true,
          sortDirection: "desc"
        },
        
        {
          key: "creationTime",
          label: "Date",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      LedgerMaster: {
        ledgerId: "",
        ledger: "",
        incomeDirect: "",
        shipmentType: "",
        moduelType: "",
        jobType: "",
        isLedgerActive: true,
        TypeofAdd: "Ledger Master Add"
      },
      LedgerMasterError: [
        "Please Enter Ledger Name",
        "Please Select Income Direct",
        "Please Select Shipment Type",
        "Please Select Moduel Type",
        "Please Select Job Type"
        // "Please Enter Ledger COde"
      ],
      errorList: {
        ledger: "",
        incomeDirect: "",
        shipmentType: "",
        moduelType: "",
        jobType: ""
        // LedgerCode: ""
      },
      jobType_items: [],
      moduelType_items: [],
      shipmentType_items: [],
      MasterLedgerList: [],
      validate: true,
      shipmentTypeList: [
        {
          text: "Sea",
          value: "Sea"
        },
        {
          text: "Air",
          value: "Air"
        }
      ],
      moduelTypeList: [
        {
          text: "Export",
          value: "Export"
        },
        {
          text: "Import",
          value: "Import"
        },
        {
          text: "Domestic",
          value: "Domestic"
        }
      ],
      jobTypeList: [
        {
          text: "FF",
          value: "FF"
        },
        {
          text: "CC",
          value: "CC"
        },
        {
          text: "TPT",
          value: "TPT"
        },
        {
          text: "MISC",
          value: "MISC"
        },
        {
          text: "YARD",
          value: "YARD"
        },
        {
          text: "IB",
          value: "IB"
        }
      ],
      TAXPercentageArr: [
        {
          tax_percentage: "",
          value: "",
          text: "",
          tax_percentage_err: ""
        }
      ],

      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation")
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
    MultiSelect
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      this.isFileLoading = true;  // Show the spinner

      reader.onload = (e) => {
        // Read the file using the "read" method from "xlsx"
        const workbook = read(e.target.result, { type: 'binary' });

        // Get the first sheet
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];

        // Convert the worksheet to JSON with headers
        const jsonData = utils.sheet_to_json(worksheet, { header: 1 });

        if (jsonData.length) {
          // Extract headers from the first row
          // const headers = jsonData[0];
            // Extract headers from the first row
            const headers = jsonData[0].map(header => header.replace(/\s+/g, '_')); // Replace spaces with underscores


          // Create an array of objects with key-value pairs
          const formattedData = jsonData.slice(1).map(row => {
            const rowData = {};
            headers.forEach((header, index) => {
              rowData[header] = row[index] || "";  // Assign keys and values
            });
            return rowData;
          });
          console.log("formattedData=>,",formattedData)

          setTimeout(() => {  // Simulate processing delay
            this.excelData = formattedData;  // Update excelData with formatted data
            this.isFileLoading = false;  // Hide the spinner
            this.getLedgerImportData(this.excelData);
          }, 1500);  // Adjust delay if needed
          
        } else {
          this.isFileLoading = false;  // Hide the spinner if no data is found
        }
      };

      reader.readAsBinaryString(file);  // Read the file as a binary string for processing
    },
    getLedgerImportData(itemData) {
      
      let payload = {};
      
      if(itemData.length>0){
        console.log('itemData=>',itemData)
      NodeLockPannelService.importLedger({excel_data:itemData})
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data.data);
          
          if (status == 200 && data) {
            this.getData();
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
      }else{
        console.log("PLease Choose Atleast One Correct Ledger List ");
      }
    },

    validateTAXDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.TAXPercentageArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].tax_percentage == "") {
          this.TAXPercentageArr[j].tax_percentage_err =
            "Tax Percentage " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
          // break;
        } else {
          this.TAXPercentageArr[j].tax_percentage_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validateCONC = false;
      } else {
        this.validateCONC = true;
      }
    },
    getTaxPercentage(item){
      item.text=item.tax_percentage;
      item.value=item.tax_percentage;
    },
    addMultiTaxPercentage() {
      let obj = {
        tax_percentage: "",
        text: "",
        value: "",
        tax_percentage_err: ""
      };
      this.TAXPercentageArr.push(obj);
    },
    removeMultiTaxPercentage(index) {
      this.TAXPercentageArr.splice(index, 1);
    },
    SelectMultijobType(jobType_items, lastSelectItem) {
      console.log("Priyanshu Singh=>", jobType_items[0]);
      this.jobType_items = jobType_items;
      this.LedgerMaster.jobType = jobType_items;
    },
    SelectMultimoduelType(moduelType_items, lastSelectItem) {
      console.log("Priyanshu Singh=>", moduelType_items[0]);
      this.moduelType_items = moduelType_items;
      this.LedgerMaster.moduelType = moduelType_items;
    },
    SelectMultishipmentType(shipmentType_items, lastSelectItem) {
      console.log("Priyanshu Singh=>", shipmentType_items[0]);
      this.shipmentType_items = shipmentType_items;
      this.LedgerMaster.shipmentType = shipmentType_items;
    },
    getReports(id) {
      let payload = {
        excelId: id
      };
      this.$store.dispatch(
        "common/setAllPendingReverseTallyExcel",
        JSON.stringify(payload)
      );
      let ExcelName = "";
      if (this.$store.getters["common/getAllPendingReverseTallyExcel"]) {
        ExcelName = this.$store.getters[
          "common/getAllPendingReverseTallyExcel"
        ];
        // alert(ExcelName)
        // if (ExcelName) {
        //   window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + ExcelName;
        // }
      }
    },
    clearErrVal() {
      this.LedgerMaster = {
        ledgerId: "",
        ledger: "",
        incomeDirect: "",
        shipmentType: "",
        moduelType: "",
        jobType: "",
        isLedgerActive: true,
        TypeofAdd: "Ledger Master Add"
      };
      this.shipmentType_items= [];
      this.moduelType_items= [];
      this.jobType_items = [];
      console.log(this.LedgerMaster,"masterrr")
      this.errorList = {
        ledger: "",
        incomeDirect: "",
        shipmentType: "",
        moduelType: "",
        jobType: ""
        // LedgerCode: ""
      };
      this.TAXPercentageArr = [
        {
          tax_percentage: "",
          text: "",
          value: "",
          tax_percentage_err: ""
        }
      ];
    },

    editLedgerLocation(item) {
      this.TAXPercentageArr = [];
      this.clearErrVal();
      this.addEditCard = true;
      item.TypeofAdd = "Ledger Master Add";
      this.LedgerMaster = item;
      let shipmentType = item.shipmentType.split(",");
      let moduelType = item.moduelType.split(",");
      let jobType = item.jobType.split(",");
      shipmentType.forEach((mval, mkey) => {
        let mObj = {
          text: mval,
          value: mval
        };
        this.shipmentType_items.push(mObj);
      });
      moduelType.forEach((mval, mkey) => {
        let mObj = {
          text: mval,
          value: mval
        };
        this.moduelType_items.push(mObj);
      });
      jobType.forEach((jval, jkey) => {
        let jObj = {
          text: jval,
          value: jval
        };
        this.jobType_items.push(jObj);
      });
      this.TAXPercentageArr = item.TAXPercentage?JSON.parse(item.TAXPercentage):[
        {
          tax_percentage: "",
          text: "",
          value: "",
          tax_percentage_err: ""
        }
      ];
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function() {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    activateLedgerMaster() {
      if (
        this.LedgerMaster.isLedgerActive == 1 ||
        this.LedgerMaster.isLedgerActive == true
      ) {
        this.LedgerMaster.isLedgerActive = false;
      } else if (
        this.LedgerMaster.isLedgerActive == 0 ||
        this.LedgerMaster.isLedgerActive == false
      ) {
        this.LedgerMaster.isLedgerActive = true;
      }
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getData("0", "0", "1", "1");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getData("0", "0", "1", "1");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },
    validateLedgerMaster() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.LedgerMaster[x] == "" ||
          this.LedgerMaster[x] == undefined ||
          this.LedgerMaster[x] == null
        ) {
          this.errorList[x] = this.LedgerMasterError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    addLedgerMaster() {
      this.LedgerMaster.moduelType = "";
      this.LedgerMaster.jobType = "";
      this.LedgerMaster.shipmentType = "";

      if (!this.LedgerMaster.shipmentType) {
        this.LedgerMaster.shipmentType = "";
        this.shipmentType_items.forEach(item_val => {
          if (this.LedgerMaster.shipmentType) {
            this.LedgerMaster.shipmentType =
              this.LedgerMaster.shipmentType + "," + item_val.value;
          } else {
            this.LedgerMaster.shipmentType = item_val.value;
          }
        });
      }

      if (!this.LedgerMaster.moduelType) {
        this.LedgerMaster.moduelType = "";
        this.moduelType_items.forEach(item_val => {
          if (this.LedgerMaster.moduelType) {
            this.LedgerMaster.moduelType =
              this.LedgerMaster.moduelType + "," + item_val.value;
          } else {
            this.LedgerMaster.moduelType = item_val.value;
          }
        });
      }

      if (!this.LedgerMaster.jobType) {
        this.LedgerMaster.jobType = "";
        this.jobType_items.forEach(item_val => {
          if (this.LedgerMaster.jobType) {
            this.LedgerMaster.jobType =
              this.LedgerMaster.jobType + "," + item_val.value;
          } else {
            this.LedgerMaster.jobType = item_val.value;
          }
        });
      }
      this.validateTAXDetail();
      this.validateLedgerMaster();
      this.LedgerMaster.TypeofAdd = "Ledger Master Add";
      if (this.validate == false) return false;
      this.isLoading = true;
      this.LedgerMaster.TAXPercentage = JSON.stringify(this.TAXPercentageArr);
      let payload = {
        itemCode: "add_Ledger_Details",
        LedgerMaster: this.LedgerMaster
      };
      payload = JSON.stringify(payload);
      if (this.validate != false) {
        CommonService.getAllProformaInvoice(payload)
          .then(response => {
            const { data, status, statusText } = response;
            if (data.ledgerId != "" && data.ledgerId != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.addEditCardFunc();
              this.getData();
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch(error => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },

    getData() {
      this.isLoading = true;
      let payload = {
        itemCode: "LedgerMasterList"
      };
      CommonService.getAllProformaInvoice(payload)
        .then(response => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            this.MasterLedgerList = data.LedgerMasterList;
            this.totalRows = data.LedgerMasterList.length;
            console.log(" Ledger Master List response=>", data);
          } else {
            this.MasterLedgerList = [];
          }

          this.isLoading = false;
        })
        .catch(error => {
          console.log("Catch on Ledger Master List Error: ", error);
        });
    },

    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.ledgerId;

      this.itemObj.isLedgerActive = this.itemObj.isLedgerActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "ledgermaster",
        tableId: "ledgerId",
        tableIsActive: "isLedgerActive",
        value1: this.itemObj.isLedgerActive,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    },
    changeToAir(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.ledgerId;

      this.itemObj.is_air = this.itemObj.is_air == 1 ? 0 : 1;
      let paylod = {
        tableName: "ledgermaster",
        tableId: "ledgerId",
        tableIsActive: "is_air",
        value1: this.itemObj.is_air,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData();
          }
        })
        .catch((error) => {});
    }
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}

/* Spinner styling */
.vue-loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Fade-in animation for table */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}


/* Keyframe animation for table appearance */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>


// WEBPACK FOOTER //
// ledgerMaster.vue?69364584